<div class="mobile-side-menu white-bg h-100 z-index-1000 d-sm-none d-flex flex-column position-fixed top-0" [ngClass]="{'open':mobileMenuOpen}">
  <div class="modal-header text-uppercase py-2 font-size-16">
    <div class="modal-title"><ng-content select="app-mobile-side-menu-title"></ng-content></div>
    <button type="button" class="close" (click)="close()">&times;</button>
  </div>
  <ng-content></ng-content>
</div>
